import { Calendar, Clock, MapPin, Trash2 } from "lucide-react";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { CartItem } from "@/contexts/CartContext";

interface CartEventItemProps {
  item: CartItem;
  onRemove: () => void;
}

export function CartEventItem({ item, onRemove }: CartEventItemProps) {
  const formatEventDate = (dateStr?: string) => {
    if (!dateStr) return "";
    try {
      return format(new Date(dateStr), "EEE d MMM", { locale: es });
    } catch {
      return dateStr;
    }
  };

  return (
    <div className="p-3 rounded-lg bg-secondary/50 border border-primary/20">
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1">
          <p className="font-medium text-sm">{item.title}</p>
          {item.meta && (
            <div className="mt-1 space-y-0.5 text-xs text-muted-foreground">
              {item.meta.event_date && (
                <div className="flex items-center gap-1">
                  <Calendar size={12} />
                  <span className="capitalize">
                    {formatEventDate(item.meta.event_date)}
                  </span>
                  {item.meta.event_time && (
                    <>
                      <Clock size={12} className="ml-1" />
                      <span>{item.meta.event_time.slice(0, 5)}</span>
                    </>
                  )}
                </div>
              )}
              {item.meta.location && (
                <div className="flex items-center gap-1">
                  <MapPin size={12} />
                  <span>{item.meta.location}</span>
                </div>
              )}
            </div>
          )}
          <p className="text-primary font-bold mt-2">
            ${item.unit_price.toLocaleString("es-AR")}
          </p>
        </div>
        <button
          onClick={onRemove}
          className="p-1.5 text-muted-foreground hover:text-destructive transition-colors rounded hover:bg-destructive/10"
        >
          <Trash2 size={16} />
        </button>
      </div>
    </div>
  );
}
